import { render } from "./CharacterCreate.vue?vue&type=template&id=5a783bde&scoped=true"
import script from "./CharacterCreate.vue?vue&type=script&lang=js"
export * from "./CharacterCreate.vue?vue&type=script&lang=js"

import "./CharacterCreate.vue?vue&type=style&index=0&id=5a783bde&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5a783bde"

export default script